// extracted by mini-css-extract-plugin
export default {"label":"FormDatePicker_label__0firP"};